export default __webpack_public_path__ + "static/media/copy.fd9aa218.svg";